import React from 'react';
import MuiSkeleton, { SkeletonProps } from '@mui/material/Skeleton';

const Skeleton = (properties: SkeletonProps) => {
  const { className, ...rest } = properties;
  return (
    <MuiSkeleton
      className={`loader ${className ?? ''}`}
      {...rest}
    />
  );
};

export default Skeleton;
